import React from "react";
import { useState } from "react";
import moment from "moment";
import { useEffect } from "react";
import { Dropdown } from "../assets";

const intervalTypes = [
	["weeks", 60 * 24 * 7],
	["days", 60 * 24],
	["hours", 60],
	["minutes", 1]
];

function pickAppropriateIntervalType(value) {
	// If it's a multiple of one of the types, use that.
	if (!value) return "minutes";
	return intervalTypes.find(([, factor]) => value % factor === 0)[0];
}

export default function TimeIntervalSelector({ value, onChange }) {

	const [intervalType, setIntervalType] = useState(pickAppropriateIntervalType(value));
	const [duration, setDuration] = useState(moment.duration(value, "minutes"));

	useEffect(() => {
		// When the value changes, update the duration.
		setDuration(moment.duration(value, "minutes"));
	}, [value]);

	return <div className="timeIntervalSelector flexy">
		<input
			style={{ marginBottom: 0 }}
			type="text"
			value={duration.as(intervalType)}
			onChange={e => {
				const number = Number((e.target.value || "0")
					.replace(/[^\d]/g, ""));
				onChange(moment.duration(number, intervalType).as("minutes"));
			}}
		/>
		<Dropdown
			value={intervalType}
			placeholder="..."
			options={intervalTypes.map(([value]) => ({ name: value, value }))}
			onSelect={newType => {
				// Get the numerical portion of the moment in its current interval type.
				const number = duration.as(intervalType);
				// And create a new one with the new type.
				onChange(moment.duration(number, newType).as("minutes"));
				// And update state.
				setIntervalType(newType);
			}}
		/>
	</div>
}